import axios from 'axios';

export const getDbTables = async () => {
    const { data } = await axios.get('/api/db/tables');
    return data;
};

export const getDbTableRows = async ({ database = 'main', table, limit = 50, offset = 0 } = {}) => {
    if (!table) {
        throw new Error('table is required');
    }
    const params = {
        database,
        table,
        limit,
        offset,
    };
    const { data } = await axios.get('/api/db/table', { params });
    return data;
};

export const runDbQuery = async ({ database = 'main', sql }) => {
    if (!sql) {
        throw new Error('sql is required');
    }
    const { data } = await axios.post('/api/db/query', { database, sql });
    return data;
};

export const getDbLogs = async ({ limit = 100, level, event } = {}) => {
    const params = { limit };
    if (level) params.level = level;
    if (event) params.event = event;
    const { data } = await axios.get('/api/db/logs', { params });
    return data;
};

export const getDbMigrationStatus = async () => {
    const { data } = await axios.get('/api/db/migration-test/status');
    return data;
};

export const runDbMigrationTests = async ({ tests = [] } = {}) => {
    const payload = Array.isArray(tests) && tests.length > 0 ? { tests } : {};
    const { data } = await axios.post('/api/db/migration-test/run', payload);
    return data?.results || {};
};
